export default __webpack_public_path__ + "static/media/pantry1-afterC-2048w.595ac8c3.avif";